import { Action, createActions } from 'redux-actions';
import { LocationType } from '../../../types';
import { Location } from '../../../LocationAutocomplete/types';
import { SegmentsState } from './reducers';

export const TOGGLE_MULTI_CITY = 'TOGGLE_MULTI_CITY';
export const ADD_SEGMENT = 'ADD_SEGMENT';
export const REMOVE_SEGMENT = 'REMOVE_SEGMENT';
export const SET_DATE = 'SET_DATE';
export const SET_DATE_MULTI_CITY = 'SET_DATE_MULTI_CITY';
export const CLEAR_DATES = 'CLEAR_DATES';
export const SET_LOCATION = 'SET_LOCATION';
export const SWAP_LOCATIONS = 'SWAP_LOCATIONS';
export const SWAP_MULTI_LOCATIONS = 'SWAP_MULTI_LOCATIONS';
export const SET_SEGMENTS = 'SET_SEGMENTS';
export const SET_MULTI_CITY = 'SET_MULTI_CITY';
export const SET_MULTI_CITY_ROUTE = 'SET_MULTI_CITY_ROUTE';

export type OnDateChangeHandler<R> = (date: Date, isBackDate?: boolean) => R;
export type SetDateActionPayload = { date: Date; isBackDate?: boolean };
export type SetDateAction = Action<SetDateActionPayload>;

export type OnDateMultiChangeHandler = (date: Date, segmentIndex: number) => SetDateMultiAction;
export type SetDateMultiActionPayload = { date: Date; segmentIndex: number };
export type SetDateMultiAction = Action<SetDateMultiActionPayload>;

export type ClearDatesAction = Action<number>;
export type ClearDatesHandler = (segmentIndex: number) => ClearDatesAction;

export type RemoveSegmentAction = Action<number>;
export type OnRemoveSegmentHandler = (segmentIndex: number) => RemoveSegmentAction;

export type SetSegmentsAction = Action<SegmentsState>;

export type SetLocationActionPayload = { location: Location; type: LocationType; segmentIndex?: number };
export type SetLocationAction = Action<SetLocationActionPayload>;
export type OnSetLocationHandler<R> = (location: Location, type: LocationType, segmentIndex?: number) => R;

export const {
	toggleMultiCity,
	addSegment,
	removeSegment,
	setDate,
	setDateMultiCity,
	clearDates,
	setLocation,
	swapLocations,
	swapMultiLocations,
	setSegments,
	setMultiCity
} = createActions({
	[SET_DATE]: (date: Date, isBackDate = false) => ({ date, isBackDate }),
	[SET_DATE_MULTI_CITY]: (date: Date, segmentIndex: number) => ({ date, segmentIndex }),
	[TOGGLE_MULTI_CITY]: null,
	[SET_MULTI_CITY]: (value: boolean) => value,
	[ADD_SEGMENT]: null,
	[CLEAR_DATES]: (segmentIndex: number) => segmentIndex,
	[REMOVE_SEGMENT]: (segmentIndex: number) => segmentIndex,
	[SET_LOCATION]: (location: Location, type: LocationType, segmentIndex?: number) => ({
		location,
		type,
		segmentIndex
	}),
	[SWAP_LOCATIONS]: null,
	[SWAP_MULTI_LOCATIONS]: (segmentIndex: number) => segmentIndex,
	[SET_SEGMENTS]: (segments: SegmentsState) => segments
});
